export default {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.services': 'الخدمات',
  'nav.register': 'التسجيل',
  'nav.blog': 'المدونة',
  'nav.tryFree': 'جرب مجاناً',

  // Hero Section
  'hero.title1': 'تحكم كامل في',
  'hero.title2': 'إدارة صالتك الرياضية',
  'hero.description': 'نظام إدارة متكامل يوفر لك لوحة تحكم احترافية لتتبع الإيرادات والاشتراكات والحضور والفواتير في مكان واحد. مع تقارير تحليلية متقدمة لاتخاذ قرارات أفضل.',
  'hero.tryFree': 'جرب مجاناً لمدة 14 يوم',
  'hero.requestDemo': 'طلب عرض توضيحي',
  'hero.revenue': 'الإيرادات',
  'hero.totalMemberships': 'إجمالي الاشتراكات',
  'hero.active': 'نشط',
  'hero.inactive': 'غير نشط',
  'hero.newMemberships': 'اشتراكات جديدة',
  'hero.thisMonth': 'هذا الشهر',

  // Why Choose Section
  'whyChoose.title': 'لماذا 5vix',
  'whyChoose.description': 'نظام متكامل يلبي جميع احتياجات صالتك الرياضية بواجهة سهلة الاستخدام ومميزات قوية',
  'whyChoose.timeSaving': 'توفير الوقت',
  'whyChoose.timeSavingDesc': 'أتمتة العمليات اليومية وتقليل الوقت المستغرق في المهام الإدارية بنسبة 70% للتركيز على نمو أعمالك',
  'whyChoose.analytics': 'تحليلات ذكية',
  'whyChoose.analyticsDesc': 'رؤية شاملة لأداء صالتك الرياضية مع تقارير تفصيلية ولوحات تحكم قابلة للتخصيص',
  'whyChoose.experience': 'تجربة أعضاء أفضل',
  'whyChoose.experienceDesc': 'تطبيق للأعضاء يتيح حجز الحصص وتتبع التقدم والتواصل المباشر مع المدربين',

  // Services Section
  'services.title': 'كل ما تحتاجه',
  'services.description': 'مجموعة أدوات متكاملة مصممة لأصحاب الصالات الرياضية لإدارة أعمالهم بكفاءة',
  'services.membership.title': 'إدارة الاشتراكات',
  'services.membership.description': 'إدارة بيانات الأعضاء والاشتراكات والتجديد التلقائي وإشعارات انتهاء العضوية بسهولة',
  'services.membership.feature1': 'ملفات تعريف مخصصة للأعضاء',
  'services.membership.feature2': 'تجديد وفوترة تلقائية',
  'services.membership.feature3': 'بطاقات عضوية رقمية',
  'services.scheduling.title': 'جدولة الحصص',
  'services.scheduling.description': 'جدولة الحصص وإدارة المدربين والسماح للأعضاء بالحجز عبر الإنترنت',
  'services.scheduling.feature1': 'جدولة بالسحب والإفلات',
  'services.scheduling.feature2': 'بوابة حجز عبر الإنترنت',
  'services.scheduling.feature3': 'تذكيرات تلقائية',
  'services.payment.title': 'المدفوعات والفواتير',
  'services.payment.description': 'قبول المدفوعات وإنشاء الفواتير وتتبع الأمور المالية في الوقت الفعلي',
  'services.payment.feature1': 'طرق دفع متعددة',
  'services.payment.feature2': 'فواتير تلقائية',
  'services.payment.feature3': 'تقارير جاهزة للضرائب',
  'services.analytics.title': 'التقارير والتحليلات',
  'services.analytics.description': 'رؤى عميقة لأعمالك مع لوحات تحكم مرئية وتقارير قابلة للتصدير',
  'services.analytics.feature1': 'تتبع الإيرادات والمصروفات',
  'services.analytics.feature2': 'تقارير الحضور والاحتفاظ',
  'services.analytics.feature3': 'لوحات مؤشرات الأداء',
  'services.memberApp.title': 'تطبيق الأعضاء',
  'services.memberApp.description': 'تطبيق مخصص لأعضائك للحجز والتتبع والتواصل أثناء التنقل',
  'services.memberApp.feature1': 'حجز الحصص والجلسات',
  'services.memberApp.feature2': 'تتبع الأهداف والتقدم',
  'services.memberApp.feature3': 'محادثة مع المدربين',
  'services.inventory.title': 'المخزون ونقطة البيع',
  'services.inventory.description': 'إدارة المنتجات وتتبع المخزون ومعالجة المبيعات من شاشة واحدة',
  'services.inventory.feature1': 'كتالوج المنتجات',
  'services.inventory.feature2': 'نقطة بيع مدمجة',
  'services.inventory.feature3': 'تقارير المبيعات والأرباح',

  // Statistics Section
  'stats.revenue': 'الإيرادات',
  'stats.netProfit': 'صافي الربح',
  'stats.members': 'الأعضاء',
  'stats.fromPreviousMonth': 'من الشهر السابق',
  'stats.income': 'الدخل',
  'stats.expenses': 'المصروفات',
  'stats.organicSources': 'مصادر الزوار',
  'stats.socialMedia': 'وسائل التواصل',
  'stats.friends': 'الإحالات',
  'stats.directVisit': 'زيارة مباشرة',
  'stats.calls': 'مكالمات هاتفية',
  'stats.billingStatus': 'حالة الفواتير',
  'stats.draft': 'مسودة',
  'stats.sent': 'مرسلة',
  'stats.paid': 'مدفوعة',
  'stats.partiallyPaid': 'جزئية',
  'stats.overdue': 'متأخرة',
  'stats.cancelled': 'ملغاة',

  // Registration Section
  'register.title1': 'ابدأ رحلتك مع',
  'register.title2': '5vix',
  'register.title3': 'اليوم',
  'register.description': 'سجل الآن واحصل على 14 يوماً مجاناً. لا حاجة لبطاقة ائتمان، بدون التزامات.',
  'register.quickSetup': 'إعداد سريع',
  'register.quickSetupDesc': 'ابدأ العمل في دقائق مع إعداد موجه ودعم فني على مدار الساعة',
  'register.dataSafe': 'بياناتك آمنة',
  'register.dataSafeDesc': 'تشفير بمستوى بنكي ونسخ احتياطية منتظمة وامتثال كامل لحماية البيانات',
  'register.support': 'دعم 24/7',
  'register.supportDesc': 'فريق دعم متخصص جاهز لمساعدتك في أي وقت تحتاجه',
  'register.formTitle': 'أنشئ حسابك',
  'register.firstName': 'الاسم الأول',
  'register.lastName': 'اسم العائلة',
  'register.gymName': 'اسم الصالة الرياضية',
  'register.email': 'البريد الإلكتروني',
  'register.phone': 'رقم الهاتف',
  'register.package': 'الباقة',
  'register.selectPackage': 'اختر الباقة',
  'register.basic': 'أساسية',
  'register.professional': 'احترافية',
  'register.integrated': 'متكاملة',
  'register.createAccount': 'ابدأ عبر واتساب',

  // Testimonials Section
  'testimonials.title': 'موثوق من أصحاب الصالات',
  'testimonials.description': 'استمع إلى أصحاب الصالات الرياضية الذين يديرون أعمالهم مع 5vix',
  'testimonials.customer1.name': 'فهد جمال',
  'testimonials.customer1.role': 'مالك، صالة فيت بانش',
  'testimonials.customer1.text': 'لنا في المجال حوالي 6 سنوات وكنا نعاني من مشاكل في الرواتب والحضور. بعد التحول إلى 5vix، أصبح كل شيء سهلاً من الجوال. والدعم دائماً سريع في حل أي مشكلة.',
  'testimonials.customer2.name': 'أحمد خيرات',
  'testimonials.customer2.role': 'مالك، سايبورج كاليسثينكس',
  'testimonials.customer2.text': 'الإتقان والتطوير المستمر والخدمة الممتازة تلخص تجربتي مع 5vix. أنصح أي شخص يبحث عن تطوير صالته أن يبدأ رحلته مع هذا النظام.',
  'testimonials.customer3.name': 'عبدالله الراشد',
  'testimonials.customer3.role': 'مالك، سلسلة باور جيم',
  'testimonials.customer3.text': 'دعم فني ممتاز وتحديثات مستمرة تضيف قيمة حقيقية. التقارير والتحليلات ساعدتني أفهم أعمالي بشكل أفضل وأتخذ قرارات استراتيجية أذكى.',

  // Blog Section
  'blog.title': 'المدونة',
  'blog.description': 'نصائح وإرشادات وأفكار لمساعدتك في تنمية صالتك وخدمة أعضائك بشكل أفضل',
  'blog.subtitle': 'نصائح الخبراء والأدلة والرؤى لمساعدتك على تحقيق أهداف اللياقة البدنية',
  'blog.allArticles': 'جميع المقالات',
  'blog.fitness': 'لياقة بدنية',
  'blog.nutrition': 'تغذية',
  'blog.wellness': 'صحة',
  'blog.training': 'تدريب',
  'blog.newsletterTitle': 'ابق على اطلاع',
  'blog.newsletterDesc': 'احصل على أحدث نصائح اللياقة وإدارة الصالات الرياضية في بريدك الإلكتروني',
  'blog.readMore': 'اقرأ المزيد',
  'blog.viewAll': 'عرض جميع المقالات',

  'blog.article1.title': '10 استراتيجيات لزيادة الاحتفاظ بالأعضاء',
  'blog.article1.description': 'اكتشف استراتيجيات مثبتة للحفاظ على تفاعل أعضائك وتقليل معدل التسرب في صالتك.',
  'blog.article1.author': 'أحمد الشمري',
  'blog.article1.excerpt': 'اكتشف استراتيجيات مثبتة للحفاظ على تفاعل أعضائك وتحفيزهم وولائهم لصالتك. تعلم كيف تقلل الصالات الرائدة معدل التسرب وتبني مجتمعات مزدهرة.',
  'blog.article2.title': 'كيفية توظيف أفضل المدربين لصالتك',
  'blog.article2.description': 'دليل شامل للعثور على المدربين المحترفين وتوظيفهم وتطويرهم.',
  'blog.article2.author': 'نورة الخالدي',
  'blog.article2.excerpt': 'دليل شامل لتوظيف وتدقيق وتطوير مدربين على مستوى عالمي سيرتقون بتجربة صالتك ويحافظون على عودة الأعضاء.',
  'blog.article3.title': 'تحليل البيانات: مفتاح نجاح الصالة الرياضية',
  'blog.article3.description': 'كيفية استخدام تحليل البيانات لاتخاذ قرارات أفضل وزيادة إيرادات صالتك.',
  'blog.article3.author': 'خالد السعيد',
  'blog.article3.excerpt': 'تعلم كيف يستخدم أصحاب الصالات الرائدة البيانات لتحسين الأسعار وجدولة الحصص بشكل أذكى وزيادة الإيرادات من خلال اتخاذ قرارات قائمة على الأدلة.',
  'blog.article4.title': 'تدريب HIIT: الفوائد وأفضل الممارسات',
  'blog.article4.excerpt': 'استكشف العلم وراء التدريب المتقطع عالي الكثافة وكيفية دمجه بفعالية في روتين اللياقة البدنية الخاص بك.',
  'blog.article5.title': 'أساسيات التمرين المنزلي: لا حاجة للصالة الرياضية',
  'blog.article5.excerpt': 'احصل على اللياقة من راحة منزلك مع هذه التمارين الفعالة والمعدات البسيطة. مثالي للجداول المزدحمة.',
  'blog.article6.title': 'تناول البروتين: كم تحتاج حقاً؟',
  'blog.article6.excerpt': 'دحض الخرافات حول استهلاك البروتين وتقديم توصيات قائمة على الأدلة لأهداف اللياقة المختلفة.',
  'blog.article7.title': 'تحسين النوم لأداء أفضل',
  'blog.article7.excerpt': 'تعرف على كيفية تأثير جودة النوم على نتائج لياقتك واكتشف استراتيجيات لتحسين جودة نومك.',
  'blog.article8.title': 'تدريب القوة للمبتدئين: دليل كامل',
  'blog.article8.excerpt': 'كل ما تحتاج لمعرفته لبدء رحلة تدريب القوة بأمان وفعالية.',
  'blog.article9.title': 'المرونة والحركة: الحلقة المفقودة',
  'blog.article9.excerpt': 'لماذا يعد تدريب المرونة ضرورياً للياقة البدنية الشاملة وكيفية دمجه في روتينك للحصول على نتائج أفضل.',

  // CTA Section
  'cta.title': 'هل أنت مستعد لتطوير صالتك؟',
  'cta.description': 'انضم إلى آلاف الصالات الرياضية التي تستخدم 5vix لتبسيط العمليات وتقديم تجربة رائعة للأعضاء.',
  'cta.button': 'ابدأ مجاناً اليوم',

  // Footer
  'footer.description': 'منصة شاملة لإدارة الصالات الرياضية تساعدك على تنظيم الاشتراكات وجدولة الحصص وتتبع الحضور وتحليل الأداء بسهولة.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.support': 'الدعم',
  'footer.helpCenter': 'مركز المساعدة',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.contactUs': 'اتصل بنا',
  'footer.terms': 'الشروط والأحكام',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.newsletter': 'تابعنا على واتساب',
  'footer.newsletterDesc': 'اشترك ليصلك أحدث النصائح والتحديثات مباشرة على واتساب',
  'footer.subscribe': 'اشترك',
  'footer.whatsappPlaceholder': 'رقم الواتساب...',
  'footer.cookies': 'ملفات تعريف الارتباط',
  'footer.copyright': '© 2025 5vix. جميع الحقوق محفوظة.',

  // Help Center
  helpCenter: {
    title: 'مركز المساعدة',
    subtitle: 'ابحث عن إجابات واحصل على الدعم الذي تحتاجه',
    searchPlaceholder: 'ابحث عن المساعدة...',
    gettingStarted: 'البدء',
    membership: 'العضوية',
    billing: 'الفواتير',
    technical: 'التقنية',
    mobileApp: 'تطبيق الجوال',
    reports: 'التقارير',
    frequentlyAsked: 'الأسئلة الشائعة',
    noResults: 'لم يتم العثور على نتائج. جرب كلمات مفتاحية مختلفة.',
    stillNeedHelp: 'هل لا تزال بحاجة إلى مساعدة؟',
    contactTeam: 'فريق الدعم لدينا هنا لمساعدتك على مدار الساعة',
    whatsappSupport: 'الدعم عبر واتساب',
    callUs: 'اتصل بنا',
    faq1: { question: 'كيف أبدأ مع 5vix؟', answer: 'البدء سهل! سجل للحصول على نسخة تجريبية مجانية، وأكمل معالج الإعداد السريع، وابدأ في إدارة صالتك الرياضية فوراً. سيرشدك فريقنا خلال كل خطوة.' },
    faq2: { question: 'ما هي طرق الدفع التي تقبلونها؟', answer: 'نقبل جميع بطاقات الائتمان الرئيسية (فيزا، ماستركارد، أمريكان إكسبريس)، وPayPal، والتحويلات البنكية. تتم معالجة جميع المدفوعات بشكل آمن من خلال بوابتنا المشفرة.' },
    faq3: { question: 'كيف أضيف أعضاء جدد؟', answer: 'اذهب إلى قسم الأعضاء في لوحة التحكم، انقر على "إضافة عضو"، املأ تفاصيلهم، اختر خطة العضوية، وقم بمعالجة الدفع. سيتلقى الأعضاء بريداً إلكترونياً ترحيبياً تلقائياً.' },
    faq4: { question: 'هل يمكن للأعضاء حجز الحصص من خلال تطبيق الجوال؟', answer: 'نعم! يمكن للأعضاء تنزيل تطبيقنا وتسجيل الدخول وحجز الحصص وعرض الجداول وتتبع التقدم وإدارة عضويتهم مباشرة من هواتفهم.' },
    faq5: { question: 'كيف أقوم بإعداد الفواتير المتكررة؟', answer: 'يتم إعداد الفواتير المتكررة تلقائياً عند إنشاء خطة عضوية. قم بتكوين التكرار (شهري، ربع سنوي، سنوي) وسيتولى النظام الباقي.' },
    faq6: { question: 'ماذا يحدث إذا فشل الدفع؟', answer: 'يحاول النظام تلقائياً مرة أخرى بعد 3 أيام. يتلقى الأعضاء إشعارات بريد إلكتروني حول فشل الدفع. يمكنك أيضاً معالجة المدفوعات يدوياً من ملف تعريف العضو.' },
    faq7: { question: 'كيف أقوم بالتكامل مع أنظمتي الحالية؟', answer: 'يوفر 5vix وصول API ويدعم تكاملات الطرف الثالث المختلفة. اتصل بفريقنا التقني لمناقشة احتياجاتك المحددة.' },
    faq8: { question: 'هل بياناتي آمنة؟', answer: 'بالتأكيد. نستخدم تشفير بمستوى بنكي (SSL/TLS)، ومراكز بيانات آمنة مع مراقبة 24/7، ونسخ احتياطية منتظمة، وامتثال كامل لمعايير حماية البيانات.' },
    faq9: { question: 'كيف أقوم بتنزيل تطبيق الجوال؟', answer: 'تطبيق 5vix متاح على iOS و Android. ابحث عن "5vix" في App Store أو Google Play Store، أو زر موقعنا للحصول على روابط التنزيل المباشرة.' },
    faq10: { question: 'هل يمكنني تخصيص العلامة التجارية لتطبيق الجوال؟', answer: 'نعم! في الخطط الاحترافية والمتكاملة، يمكنك تخصيص التطبيق بشعار صالتك وألوانها وعلامتها التجارية. اتصل بالدعم للإعداد.' },
    faq11: { question: 'ما هي التقارير المتاحة؟', answer: 'نقدم تحليل الإيرادات وإحصائيات العضوية وتتبع الحضور وشعبية الحصص وأداء المدربين وتقارير مخصصة. جميعها قابلة للتصدير إلى PDF أو Excel.' },
    faq12: { question: 'هل يمكنني جدولة التقارير التلقائية؟', answer: 'نعم! قم بجدولة التقارير ليتم إنشاؤها وإرسالها عبر البريد الإلكتروني يومياً أو أسبوعياً أو شهرياً من قسم التقارير.' },
  },

  // Terms
  terms: {
    title: 'الشروط والأحكام',
    lastUpdated: 'آخر تحديث: يناير 2025',
    section1: { title: '1. قبول الشروط', content1: 'من خلال الوصول إلى نظام إدارة الصالات الرياضية 5vix واستخدامه، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق، فلا يجوز لك استخدام خدماتنا.', content2: 'تنطبق هذه الشروط على جميع المستخدمين بما في ذلك أصحاب الصالات والمسؤولين والمدربين والأعضاء.' },
    section2: { title: '2. حسابات المستخدمين والتسجيل', content: 'لاستخدام خدماتنا، يجب عليك:', item1: 'تقديم معلومات تسجيل دقيقة وكاملة', item2: 'الحفاظ على أمان بيانات اعتماد حسابك', item3: 'إخطارنا فوراً بأي وصول غير مصرح به', item4: 'تحمل المسؤولية عن جميع الأنشطة تحت حسابك' },
    section3: { title: '3. وصف الخدمة', content: 'توفر 5vix منصة شاملة لإدارة الصالات الرياضية تتضمن:', item1: 'إدارة الأعضاء وتتبعهم', item2: 'جدولة الحصص والحجز', item3: 'معالجة الدفع والفواتير', item4: 'تحليلات الأداء والتقارير', item5: 'الوصول إلى تطبيق الجوال للأعضاء والموظفين' },
    section4: { title: '4. شروط الدفع', content1: 'يتم إصدار فواتير رسوم الاشتراك مقدماً شهرياً أو سنوياً. جميع الرسوم غير قابلة للاسترداد إلا كما يقتضي القانون.', content2: 'أنت تفوضنا بتحصيل رسوم من طريقة الدفع الخاصة بك. إذا فشل الدفع، فقد نعلق أو ننهي وصولك.' },
    section5: { title: '5. مسؤوليات المستخدم', content: 'يوافق المستخدمون على:', item1: 'استخدام الخدمة فقط للأغراض القانونية', item2: 'عدم التدخل في الخدمة أو تعطيلها', item3: 'عدم محاولة الوصول غير المصرح به إلى أي جزء من النظام', item4: 'الامتثال لجميع القوانين واللوائح المعمول بها' },
    section6: { title: '6. الملكية الفكرية', content: 'جميع المحتويات والميزات والوظائف الخاصة بمنصة 5vix مملوكة لنا ومحمية بموجب قوانين حقوق النشر والعلامات التجارية والملكية الفكرية الدولية.' },
    section7: { title: '7. تحديد المسؤولية', content: 'إلى أقصى حد يسمح به القانون، لن تكون 5vix مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية.' },
    section8: { title: '8. معلومات الاتصال', content: 'إذا كان لديك أسئلة حول هذه الشروط، اتصل بنا:', whatsapp: 'واتساب:', phone: 'الهاتف:' },
    cta: { title: 'هل أنت مستعد للبدء؟', subtitle: 'انضم إلى آلاف الصالات الرياضية التي تستخدم 5vix لإدارة أعمالها', helpCenter: 'زيارة مركز المساعدة' },
  },

  // Privacy
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث: يناير 2024',
    introduction: 'في 5vix، نحن ملتزمون بحماية خصوصيتك وضمان أمان معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام والكشف عن وحماية معلوماتك.',
    section1: { title: '1. المعلومات التي نجمعها', subtitle1: 'المعلومات الشخصية', content1: 'نجمع المعلومات التي تقدمها مباشرة: الاسم والبريد الإلكتروني والهاتف وتاريخ الميلاد ومعلومات الدفع وتفاصيل عضوية الصالة الرياضية.', subtitle2: 'معلومات الاستخدام', content2: 'نجمع تلقائياً بيانات حول استخدامك لخدماتنا: أوقات تسجيل الدخول والميزات المستخدمة وبيانات التمرين وسجلات الحضور ومعلومات الجهاز.', subtitle3: 'بيانات الصحة واللياقة', content3: 'بموافقتك، قد نجمع بيانات متعلقة بالصحة مثل روتين التمارين وقياسات الجسم وأهداف اللياقة وتتبع التقدم.' },
    section2: { title: '2. كيف نستخدم معلوماتك', content: 'نستخدم المعلومات المجمعة من أجل:', item1: 'توفير وصيانة وتحسين خدماتنا', item2: 'معالجة مدفوعات العضوية وإدارة حسابك', item3: 'إرسال التحديثات المهمة والإشعارات والمواد الترويجية', item4: 'تخصيص تجربتك بتوصيات مخصصة', item5: 'تحليل أنماط الاستخدام لتحسين أداء المنصة' },
    section3: { title: '3. مشاركة المعلومات', content: 'نحن لا نبيع أو نتاجر أو نؤجر معلوماتك الشخصية. نشارك فقط: بموافقتك، أو للامتثال للالتزامات القانونية، أو لحماية حقوقنا، أو مع مزودي الخدمة بموجب سرية صارمة.' },
    section4: { title: '4. أمان البيانات', content: 'نطبق أمان بمستوى الصناعة: تشفير وخوادم آمنة وتدقيق منتظم وضوابط وصول. لا يوجد نقل عبر الإنترنت آمن بنسبة 100٪، ولا يمكننا ضمان الأمان المطلق.' },
    section5: { title: '5. ملفات تعريف الارتباط والتتبع', content: 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتذكر تفضيلاتك وتحليل حركة المرور وتخصيص المحتوى. يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال متصفحك.' },
    section6: { title: '6. حقوقك', content: 'لديك الحق في:', item1: 'الوصول إلى بياناتك الشخصية ومراجعتها', item2: 'طلب تصحيح المعلومات غير الدقيقة', item3: 'طلب حذف بياناتك (مع مراعاة المتطلبات القانونية)', item4: 'إلغاء الاشتراك في الاتصالات التسويقية في أي وقت' },
    section7: { title: '7. روابط الطرف الثالث', content: 'قد تحتوي منصتنا على روابط لمواقع طرف ثالث. نحن لسنا مسؤولين عن ممارسات الخصوصية الخاصة بهم. يرجى مراجعة سياساتهم.' },
    section8: { title: '8. التغييرات على هذه السياسة', content: 'قد نقوم بتحديث هذه السياسة لتعكس التغييرات في الممارسات أو المتطلبات القانونية. سنخطرك بالتغييرات الجوهرية من خلال نشر السياسة المحدثة وتحديث تاريخ "آخر تحديث".' },
    section9: { title: 'اتصل بنا', content: 'إذا كان لديك أسئلة حول سياسة الخصوصية هذه، اتصل بنا:' },
    cta: { title: 'هل أنت مستعد للبدء؟', subtitle: 'انضم إلى الآلاف الذين يستخدمون 5vix لتحقيق أهداف اللياقة', button: 'ابدأ التجربة المجانية' },
  },

  // Misc
  'mobile.close': 'إغلاق',
};